// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { isObject } from 'lodash'

export default function GenericCell(props) {
  const { data } = props

  if (isObject(data)) {
    const { style, value } = data

    return <div style={style}>{value}</div>
  } 
    return <div>{data}</div>
  
}

GenericCell.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]).isRequired,
}
